// extracted by mini-css-extract-plugin
export default {"button":"CategoryButton_button__D5OcF","dark":"CategoryButton_dark__odMvW","active":"CategoryButton_active__0XlBZ"};